import React from 'react'

type SectionCurveProps = {
  from: string
  to: string
  shape:
    | 'bottom-medium'
    | 'top-large'
    | 'top-medium'
    | 'top-large-with-extra-lines'
    | 'round-flat'
  style?: React.CSSProperties
  className?: string
}

function getShape({ shape, from, to }: SectionCurveProps) {
  const svgStyle = {
    minWidth: '540px',
    maxHeight: shape === 'top-large-with-extra-lines' ? '40vh' : '20vh',
    width: '100%',
  }
  switch (shape) {
    case 'bottom-medium':
      return (
        <svg
          preserveAspectRatio="none"
          width="100%"
          viewBox="0 0 1728 135"
          style={{
            background: `var(--${to})`,
            ...svgStyle,
          }}
        >
          <path
            d="M0 45.5679C399.886 152.568 1083.95 143.161 1749.14 3.04593C1807.73 -9.29178 1864.68 -22.3335 1919.9 -36H1920H0V45.5679Z"
            fill={`var(--${from})`}
          />
        </svg>
      )
    case 'top-medium':
      return (
        <svg
          preserveAspectRatio="none"
          width="100%"
          viewBox="0 0 1728 135"
          style={{
            background: `var(--${from})`,
            ...svgStyle,
          }}
        >
          <path
            d="M0 89.4321C399.886 -17.5678 1083.95 -8.16056 1749.14 131.954C1807.73 144.292 1864.68 157.333 1919.9 171H1920H0V89.4321Z"
            fill={`var(--${to})`}
          />
        </svg>
      )
    case 'top-large':
      return (
        <svg
          preserveAspectRatio="none"
          viewBox="0 0 2012 348"
          style={{
            background: `var(--${from})`,
            ...svgStyle,
          }}
        >
          <path
            d="M0 164.617C419.047 -78.5627 1135.89 -57.1827 1832.95 261.257C1894.35 289.297 1954.03 318.937 2011.9 349.997H2012H0V164.617Z"
            fill={`var(--${to})`}
          ></path>
        </svg>
      )

    case 'top-large-with-extra-lines':
      return (
        <svg
          preserveAspectRatio="none"
          viewBox="0 0 1440 606"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            background: `var(--${from})`,
            ...svgStyle,
          }}
        >
          <path
            d="M-22.5359 489.628C-76.915 527.373 -129.801 567.243 -181.099 609.001L1623 609.001L1623 357.275C1246.89 25.9092 603.478 54.9856 -22.5357 489.628L-23.0715 488.856L-22.5359 489.628Z"
            stroke="#A47BD1"
            strokeWidth="2"
          />
          <path
            d="M-213.244 520.188C-281.784 567.868 -348.436 618.239 -413.08 671.001L1855 671.002L1855 353.596C1382.25 -63.9241 573.525 -27.2739 -213.244 520.188L-213.815 519.367L-213.244 520.188Z"
            stroke="#A47BD1"
            strokeWidth="2"
          />
          <path
            opacity="0.8"
            d="M-521.502 600.986C-612.927 664.529 -701.828 731.667 -788.041 802.001L2230 802.002L2230 379.723C1601.04 -175.369 525.107 -126.623 -521.502 600.986Z"
            stroke="#A47BD1"
            strokeWidth="2"
          />
          <path
            d="M1440 389.369C1140.09 105.193 627.038 130.177 128.145 502.3C84.2034 535.067 41.4861 569.704 0.0719142 606L-0.000107268 606L1440 606L1440 389.369Z"
            fill={`var(--${to})`}
          />
        </svg>
      )
    case 'round-flat':
      return (
        <svg
          preserveAspectRatio="none"
          viewBox="0 0 1440 160"
          style={{
            background: `var(--${from})`,
            ...svgStyle,
          }}
        >
          <path
            d="M0 80C360 0, 1080 0, 1440 80L1440 160L0 160Z"
            fill={`var(--${to})`}
          />
        </svg>
      )
    default:
      return null
  }
}

export function SectionCurve({
  from = 'shade-100',
  to = 'moon-dust',
  shape = 'bottom-medium',
  style,
  className,
}: SectionCurveProps) {
  return (
    <div
      style={{
        position: 'relative',
        lineHeight: 0,
        marginBottom: '-1px',
        overflow: 'hidden',
        ...style,
      }}
      className={className}
    >
      {getShape({ shape, from, to })}
    </div>
  )
}
